import { API_ROUTES } from "../../configuration/RoutesApi"
import { PostRequest } from "../../services/ApiClientService"

export type CreateLandingLeadAnswer = {
  label: string
  value: string
}

export type CreateLandingLeadRequest = {
  name?: string
  businessName?: string
  email?: string
  phoneNumber?: string
  trafficSource?: string
  formName?: string
  answers?: CreateLandingLeadAnswer[]
}

export const useCreateLandingLead = () => {
  const handleCreateLandingLead = async (request: CreateLandingLeadRequest) => {
    const response = await PostRequest(API_ROUTES.LANDING_LEAD.CREATE, request)

    if (!response.success) throw new Error(response.message)
  }

  return { handleCreateLandingLead }
}
